export { GTM } from "./gtm";
